import React, { Component } from 'react'
import { slugify } from '../helpers'

import SectionDivider from './SectionDivider'
import SectionText from './SectionText'
import SectionImageSlider from './SectionImageSlider'
import SectionVideo from './SectionVideo'
import SectionFeaturedEvents from './SectionFeaturedEvents'
import SectionListEvents from './SectionListEvents'
import SectionButton from './SectionButton'

// This component:
// 1. Has a container that takes the json data and renders a new 'Section' for each part.
// 2. Adds the layout switcher from ACF (flexible content modules)

// The Sections component just loops through the json data.

class Sections extends Component {

    renderSection = (section, i) => {
      // Simple Object to switch which section component is needed from 'acf_fc_layout'
      const sections = {
        'text_section': <SectionText key={i} data={section} />,
        'images_section': <SectionImageSlider key={i} data={section} />,
        'video_section': <SectionVideo key={i} data={section} />,
        'featured_events': <SectionFeaturedEvents key={i} data={section} events={this.props.events} />,
        'list_events': <SectionListEvents key={i} data={section} events={this.props.events} />,
        'divider': <SectionDivider key={i} data={section} />,
        'button': <SectionButton key={i} data={section} />,
      }
      const anchor = (section.section_name) ? slugify(section.section_name) : ''
      return (
        <div key={i} id={anchor}>
          { sections[section['acf_fc_layout']] }
        </div>
      )
    }

   render() {
      const layout = this.props.data.acf.layout.map((section, i) => this.renderSection(section, i))

      return (
         <div className="Sections">
            { layout }
         </div>
      )
   }
}

export default Sections



// WEBPACK FOOTER //
// ./src/components/Sections.js